// ============================================
// components/legal/TermsOfService.js
// ============================================
import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import Layout from '../common/Layout';

const TermsOfService = () => {
  return (
    <Layout title="Terms of Service" showLogout={false} showBack>
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Box>
          <Typography variant="h4" color="primary" gutterBottom>
            Terms of Service
          </Typography>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Last updated: {new Date().toLocaleDateString()}
          </Typography>

          <Typography color="primary" paragraph>
            Welcome to Porchlight. These Terms of Service ("Terms") govern your use of
            our app and services. By creating an account or using Porchlight, you agree
            to be bound by these Terms.
          </Typography>

          <Typography variant="h6" color="primary" gutterBottom>1. Eligibility</Typography>
          <Typography color="primary" paragraph>
            You must be at least 13 years old (or the minimum age required by law in
            your country) to use Porchlight. By using our app, you represent that you
            meet these requirements.
          </Typography>

          <Typography variant="h6" color="primary" gutterBottom>2. Your Account</Typography>
          <Typography color="primary" paragraph>
            You are responsible for maintaining the confidentiality of your account
            credentials and for all activity under your account. You agree to provide
            accurate and up-to-date information when creating your account.
          </Typography>

          <Typography variant="h6" color="primary" gutterBottom>3. Use of the Service</Typography>
          <Typography color="primary" paragraph>
            Porchlight allows you to share your availability with friends by turning
            your "porchlight" on or off. You agree not to misuse the service, including
            by attempting to interfere with its operation, misrepresenting your
            identity, or using the app for unlawful purposes.
          </Typography>

          <Typography variant="h6" color="primary" gutterBottom>4. Content and Privacy</Typography>
          <Typography color="primary" paragraph>
            You control who sees your porchlight status. We do not sell your personal
            information. Please review our Privacy Policy for details on how we collect
            and use data.
          </Typography>

          <Typography variant="h6" color="primary" gutterBottom>5. Termination</Typography>
          <Typography color="primary" paragraph>
            You may stop using Porchlight at any time and request account deletion
            through the app or by contacting support. We may suspend or terminate your
            account if you violate these Terms or misuse the service.
          </Typography>

          <Typography variant="h6" color="primary" gutterBottom>6. Disclaimer of Warranties</Typography>
          <Typography color="primary" paragraph>
            Porchlight is provided "as is" without warranties of any kind, whether
            express or implied. We do not guarantee that the service will be
            uninterrupted, secure, or error-free.
          </Typography>

          <Typography variant="h6" color="primary" gutterBottom>7. Limitation of Liability</Typography>
          <Typography color="primary" paragraph>
            To the maximum extent permitted by law, Porchlight and its developers shall
            not be liable for any indirect, incidental, or consequential damages
            arising from your use of the service.
          </Typography>

          <Typography variant="h6" color="primary" gutterBottom>8. Changes to Terms</Typography>
          <Typography color="primary" paragraph>
            We may update these Terms from time to time. We will notify you of any
            material changes, and your continued use of Porchlight after changes
            indicates acceptance of the new Terms.
          </Typography>

          <Typography variant="h6" color="primary" gutterBottom>9. Contact</Typography>
          <Typography color="primary" paragraph>
            If you have questions about these Terms, please contact us at
            support@example.com.
          </Typography>
        </Box>
      </Container>
    </Layout>
  );
};

export default TermsOfService;